// actions.js
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    getUploadDocsInitialData: ['initialData'],
    initializeRequiredDocs: ['requiredDocs'],
    updateRequiredDocsState: ['requiredDocsData'],
});
export default { Creators, Types };